import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { formatDate } from "@angular/common";
import { Globals } from '../../../globals';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { IIepInstance } from '../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { CheckboxModule } from 'primeng/checkbox';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

/*------------------ user created components...  --------------------------------*/
import { IStudentDetails } from "../../../Core/IStudentDetails";
import { FormNotesService } from '../../../Services/FormNotesService';
import { IFormNotes } from "../../../Models/Forms/IFormNotes";
import { ISpedStudentDemographics } from '../../../Models/ISpedStudentDemographics';
import { IepService } from "../../../Services/IepService";
import { ILockStatus } from '../../../Models/ILockStatus';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ProgressReportsServiceLogs',
  templateUrl: './ProgressReportsServiceLogs.component.html',
  styleUrls: ['./ProgressReportsServiceLogs.component.css']
})

export class ProgressReportsServiceLogsComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _iepService: IepService;
  private _baseUrl: string;
  notesFromDB: any = [];
  messages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  studentName: string;
  schoolName: string;
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor
    (
      private globals: Globals, reportService: ReportService,
      private _frmNotesService: FormNotesService,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadFormNotesDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  loadUnLock() {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=UnLock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  LoadFormNotesDetails(): void {
    this._frmNotesService.getFormNotes(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormNotes) => {
        this.notesFromDB = res
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Vision Hearing
  save(action) {
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._frmNotesService.insertUpdateFormNotes(this.notesFromDB)
      .subscribe((res: IFormNotes) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock();
        }
        this.saveClicked = false;
        this.LoadFormNotesDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock();
    this.LoadFormNotesDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.notesFromDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.notesFromDB.iepId.toString() },
      { parameterName: 'PageNumber', parameterValue: '1' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.notesFromDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.notesFromDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
